import AccountDepositCoolingOffSettings from "@/models/Accounts/DepositAccounts/Settings/AccountDepositCoolingOffSettings";
import BaseUpdateAccountSettings from "@/models/Accounts/Shared/BaseUpdateAccountSettings";
import PeriodType from "@/models/Shared/PeriodType";

export default class UpdateAccountDepositCoolingOffSettingsRequest extends BaseUpdateAccountSettings {
    enabled: boolean = false;
    coolingOffPeriodType: PeriodType;
    coolingOffPeriodValue: number;

    public constructor(settings: AccountDepositCoolingOffSettings, updatedAt: Date) {
        super(updatedAt);
        if (settings !== null) {
            // Create a copy of settings to de-reference the original settings and avoid changing them here
            const settingsCopy = JSON.parse(JSON.stringify(settings));
            this.enabled = settingsCopy.enabled;
            this.coolingOffPeriodType = settingsCopy.coolingOffPeriodType;
            this.coolingOffPeriodValue = settingsCopy.coolingOffPeriodValue;
            this.coolingOffPeriodValue = +this.coolingOffPeriodValue;
        }
    }
}